import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import colorConstants from '../../constants/colorConstants';

const decisionStyles = makeStyles((theme: Theme) =>
  createStyles({
    decisionNode: {
      height: '90px',
      width: '90px',
      border: '1px solid #000',
      padding: '5px',
      background: 'white',
      transform: 'rotate(45deg)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    text: {
      transform: 'rotate(-45deg)',
      textAlign: 'center',
    },
    errorNode: {
      background: colorConstants.ERROR_NODE,
    },
    successNode: {
      background: colorConstants.SELECTED_COLOR,
    },
    warningNode: {
      background: colorConstants.WARNING_COLOR,
    },
    preconditionSearched: {
      background: colorConstants.CURRENTJOURNEY_PRECONDITION_COLOR,
    },
    selected: {
      background: colorConstants.SELECTED_COLOR,
    },
  }),
);

export { decisionStyles };
